import {
  AIRPORT,
  AIRPORT_CITY,
  CabsLandingStatesType,
  DESTINATION_CITY,
  RENTAL_CITY,
  SOURCE_CITY
} from '../pages/CabsLandingPage/cabsLandingPageState';

export const CAB_SEO_LANDING_STATES_LC_KEY = 'CAB_SEO_LANDING_STATES';
const CABS_LANDING_STATE_LIMIT = 5;
export const CAB_SEO_LANDING_LC_KE_PREFIX = 'CAB_SEO_LANDING_';
const CABS_CITY_LOCATION_RECENT_SEARCH_LIMIT = 6;
const CABS_AIRPORT_LOCATION_RECENT_SEARCH_LIMIT = 6;

const getLsStateKey = stateName => {
  return String(CAB_SEO_LANDING_LC_KE_PREFIX + stateName).toUpperCase();
};

export const getLocalStorageValue = (localStorageKey: string) => {
  try {
    if (typeof localStorage !== 'undefined') {
      const item = localStorage.getItem(localStorageKey);
      return item != null ? JSON.parse(item) : null;
    }
  } catch (ex) {
    console.error('Exception in getLocalStorageValue', ex);
  }
  return null;
};

export const setLocalStorageValue = (localStorageKey: string, value: any) => {
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage.setItem(localStorageKey, JSON.stringify(value));
    }
  } catch (ex) {
    console.error('Exception in setLocalStorageValue', ex);
  }
};

export const saveCabsLandingStatesInLS = newStates => {
  try {
    setLocalStorageValue(CAB_SEO_LANDING_STATES_LC_KEY, newStates);
  } catch (ex) {
    console.error('Exception in saveCabsLandingStatesInLS', ex);
  }
};

export const fetchLatestCabsLandingStatesInLS = (): CabsLandingStatesType | null => {
  try {
    const savedStates = getLocalStorageValue(CAB_SEO_LANDING_STATES_LC_KEY);
    return savedStates;
  } catch (ex) {
    console.error('Exception in fetchLatestCabsLandingStatesInLS', ex);
  }
  return null;
};

export const fetchStateFromLS = stateKey => {
  try {
    const stateValue = getLocalStorageValue(stateKey);
    return stateValue;
  } catch (ex) {
    console.error('Exception in fetchStateFromLS', ex);
  }
};

export const removeOldestState = lsState => {
  try {
    return lsState.slice(1, CABS_LANDING_STATE_LIMIT + 1);
  } catch (ex) {
    console.error('Exception in removeOldestState', ex);
  }
};

export const saveStateInLs = ({
  stateName,
  stateValue
}: {
  stateName: string;
  stateValue: any;
}) => {
  try {
    const localStorageKey = getLsStateKey(stateName);
    let stateValueFromLS = fetchStateFromLS(localStorageKey);

    if (!stateValueFromLS) {
      setLocalStorageValue(localStorageKey, [stateValue]);
    } else {
      stateValueFromLS.push(stateValue);
      if (
        stateValueFromLS &&
        stateValueFromLS.length > CABS_LANDING_STATE_LIMIT
      ) {
        stateValueFromLS = removeOldestState(stateValueFromLS);
      }
      setLocalStorageValue(localStorageKey, stateValueFromLS);
    }
  } catch (ex) {
    console.error('Exception in saveStateInLs', ex);
  }
};

export const getCityLocationsFromLs = () => {
  const cityKeys = [
    (CAB_SEO_LANDING_LC_KE_PREFIX + SOURCE_CITY).toUpperCase(),
    (CAB_SEO_LANDING_LC_KE_PREFIX + DESTINATION_CITY).toUpperCase(),
    (CAB_SEO_LANDING_LC_KE_PREFIX + RENTAL_CITY).toUpperCase(),
    (CAB_SEO_LANDING_LC_KE_PREFIX + AIRPORT_CITY).toUpperCase()
  ];

  let cityLocations: any[] = [];
  const cityLocationNameSet = new Set();

  for (const cityKey of cityKeys) {
    const fetchedCityLocations = getLocalStorageValue(cityKey);
    if (Array.isArray(fetchedCityLocations)) {
      cityLocations = cityLocations.concat(fetchedCityLocations);
    }
  }
  cityLocations = cityLocations
    .filter(({ city }) => {
      if (!cityLocationNameSet.has(city)) {
        cityLocationNameSet.add(city);
        return true;
      }
      return false;
    })
    .map(({ city, geoLocation, placeId, subText }) => {
      const recentSearchCity = {
        title: city,
        subTitle: subText,
        placeId,
        city,
        geoLocation,
        subText
      };
      return recentSearchCity;
    });

  return cityLocations.slice(0, CABS_CITY_LOCATION_RECENT_SEARCH_LIMIT);
};

export const getAirportLocationsFromLs = () => {
  try {
    const airportLocationKey = (
      CAB_SEO_LANDING_LC_KE_PREFIX + AIRPORT
    ).toUpperCase();
    let airportLocations = getLocalStorageValue(airportLocationKey);

    const airportLocationSet = new Set();
    airportLocations = Array.isArray(airportLocations)
      ? airportLocations
          .map(({ city, geoLocation, placeId, subText }) => {
            const recentSearchCity = {
              title: city,
              subTitle: subText,
              placeId,
              city,
              geoLocation,
              subText
            };
            return recentSearchCity;
          })
          .filter(recentSearchCity => {
            if (!airportLocationSet.has(recentSearchCity.placeId)) {
              airportLocationSet.add(recentSearchCity.placeId);
              return true;
            }
            return false;
          })
          .reverse()
      : [];
    return Array.isArray(airportLocations)
      ? airportLocations.slice(0, CABS_AIRPORT_LOCATION_RECENT_SEARCH_LIMIT)
      : [];
  } catch (er) {
    return [];
  }
};
